import { render, staticRenderFns } from "./label-with-text.vue?vue&type=template&id=43fea706&scoped=true&"
import script from "./label-with-text.vue?vue&type=script&lang=js&"
export * from "./label-with-text.vue?vue&type=script&lang=js&"
import style0 from "./label-with-text.vue?vue&type=style&index=0&id=43fea706&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43fea706",
  null
  
)

export default component.exports